const groups = [
  "DPIIT Startups", "MSMEs", "Students", "Universities",
  "Researchers", "Faculty", "Innovators", "Incubators",
  "Manufacturing", "Product Companies", "Design Firms", "Govt. Departments",
];

export default function BuiltFor() {
  return (
    <section className="bg-[#0f1229] text-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-5">
          Built for
        </span>
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 max-w-2xl">
          A platform for every innovator
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {groups.map((g) => (
            <div
              key={g}
              className="bg-white/5 border border-white/10 rounded-xl px-6 py-5 font-medium hover:bg-white/10 transition"
            >
              {g}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}